module.exports = __webpack_public_path__ + "img/sale3.920824f7.webp";